export default __webpack_public_path__ + "static/media/feintattack5.ad42a930.png";